/* eslint-disable */
require('file-saver');
import XLSX from "xlsx-style";

function generateArray(table) {
  var out = [];
  var rows = table.querySelectorAll('tr');
  var ranges = [];
  for (var R = 0; R < rows.length; ++R) {
    var outRow = [];
    var row = rows[R];
    var columns = row.querySelectorAll('td');
    for (var C = 0; C < columns.length; ++C) {
      var cell = columns[C];
      var colspan = cell.getAttribute('colspan');
      var rowspan = cell.getAttribute('rowspan');
      var cellValue = cell.innerText;
      if (cellValue !== "" && cellValue == +cellValue) cellValue = +cellValue;

      //Skip ranges
      ranges.forEach(function (range) {
        if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
          for (var i = 0; i <= range.e.c - range.s.c; ++i) outRow.push(null);
        }
      });

      //Handle Row Span
      if (rowspan || colspan) {
        rowspan = rowspan || 1;
        colspan = colspan || 1;
        ranges.push({
          s: {
            r: R,
            c: outRow.length
          },
          e: {
            r: R + rowspan - 1,
            c: outRow.length + colspan - 1
          }
        });
      };

      //Handle Value
      outRow.push(cellValue !== "" ? cellValue : null);

      //Handle Colspan
      if (colspan)
        for (var k = 0; k < colspan - 1; ++k) outRow.push(null);
    }
    out.push(outRow);
  }
  return [out, ranges];
};

function datenum(v, date1904) {
  if (date1904) v += 1462;
  var epoch = Date.parse(v);
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}
export function export_json_to_excel_sheets({
  header,
  dataList,
  sheetNameList,//表格sheet名称
  filename,
  autoWidth = true,
  bookType=  'xlsx'
} = {}) {
  filename = filename || 'excel-list'
  let newData = [];
  for (let i in header) {
    let array = []

    if (dataList[i].length>0) {  
      array = [...dataList[i]];
    }
    array.unshift(header[i])
    newData.push(array)
  }
  dataList = newData;
  var wb = new Workbook();
  let ws = [];
  for (let i in header) {
    ws.push(sheet_from_array_of_arrays(dataList[i]))
  }
  if (autoWidth) {
    for (let index in header) {  
      /*设置worksheet每列的最大宽度*/

      const colWidth = dataList[index].map(row => row.map(val => {
        /*先判断是否为null/undefined*/
        if (val == null) {
          return {
            'wch': 10
          };
        }
        /*再判断是否为中文*/
        else if (val.toString().charCodeAt(0) > 255) {
          return {
            'wch': val.toString().length * 2
          };
        } else {
          return {
            'wch': val.toString().length
          };
        }
      }))
      /*以第一行为初始值*/
      let result = colWidth[0];
      for (let i = 1; i < colWidth.length; i++) {
        for (let j = 0; j < colWidth[i].length; j++) {
          if (result[j]['wch'] < colWidth[i][j]['wch']) {
            result[j]['wch'] = colWidth[i][j]['wch'];
          }
        }
      }
      ws[index]['!cols'] = result;
    }
  }

  /* add worksheet to workbook */
  for (let i in header) {
    let name=`sheet${i}`
    if (sheetNameList.length > 0) {
      name=sheetNameList[i]
    }
    wb.SheetNames.push(name)
    wb.Sheets[name]=ws[i]
  }
  var wbout = XLSX.write(wb, {
    bookType: bookType,
    bookSST: false,
    type: 'binary'
  });
  saveAs(new Blob([s2ab(wbout)], {
    type: "application/octet-stream"
  }), `${filename}.${bookType}`);
  console.log(new Date().getTime())
}
function sheet_from_array_of_arrays(data, opts) {
  var ws = {};
  var range = {
    s: {
      c: 10000000,
      r: 10000000
    },
    e: {
      c: 0,
      r: 0
    }
  };
  for (var R = 0; R !== data.length; ++R) {
    for (var C = 0; C !== data[R].length; ++C) {
      if (range.s.r > R) range.s.r = R;
      if (range.s.c > C) range.s.c = C;
      if (range.e.r < R) range.e.r = R;
      if (range.e.c < C) range.e.c = C;
      var cell = {
        v: data[R][C]
      };
      if (cell.v == null) continue;
      var cell_ref = XLSX.utils.encode_cell({
        c: C,
        r: R
      });

      if (typeof cell.v === 'number') cell.t = 'n';
      else if (typeof cell.v === 'boolean') cell.t = 'b';
      else if (cell.v instanceof Date) {
        cell.t = 'n';
        cell.z = XLSX.SSF._table[14];
        cell.v = datenum(cell.v);
      } else cell.t = 's';
      cell.s = {
        //字体水平居中、垂直居中、自动换行、缩进
			  alignment:{
			    horizontal:'center', //水平居中
			    vertical: 'center',
			    wrapText: 1,
			    indent: true
			  }
      }
      ws[cell_ref] = cell;
    }
  }
  if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
  return ws;
}

function Workbook() {
  if (!(this instanceof Workbook)) return new Workbook();
  this.SheetNames = [];
  this.Sheets = {};
}

function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}

export function export_table_to_excel(id) {
  var theTable = document.getElementById(id);
  var oo = generateArray(theTable);
  var ranges = oo[1];

  /* original data */
  var data = oo[0];
  var ws_name = "sheet";

  var wb = new Workbook(),
    ws = sheet_from_array_of_arrays(data);

  /* add ranges to worksheet */
  // ws['!cols'] = ['apple', 'banan'];
  ws['!merges'] = ranges;

  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  var wbout = XLSX.write(wb, {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  });

  saveAs(new Blob([s2ab(wbout)], {
    type: "application/octet-stream"
  }), "test.xlsx")
}

export function export_json_to_excel({
  header,
  data,
  filename,
  autoWidth = true,
  bookType=  'xlsx',
  merges
} = {}) {
  /* original data */
  filename = filename || 'excel-list'
  data = [...data]
  data.unshift(header);
  var ws_name = "sheet";
  var wb = new Workbook(),
    ws = sheet_from_array_of_arrays(data);
  if (autoWidth) {
    /*设置worksheet每列的最大宽度*/
    const colWidth = data.map(row => row.map(val => {
      /*先判断是否为null/undefined*/
      if (val == null) {
        return {
          'wch': 10
        };
      }
      /*再判断是否为中文*/
      else if (val.toString().charCodeAt(0) > 255) {
        return {
          'wch': val.toString().length * 2
        };
      } else {
        return {
          'wch': val.toString().length
        };
      }
    }))
    /*以第一行为初始值*/
    let result = colWidth[0];
    for (let i = 1; i < colWidth.length; i++) {
      for (let j = 0; j < colWidth[i].length; j++) {
        if (result[j]['wch'] < colWidth[i][j]['wch']) {
          result[j]['wch'] = colWidth[i][j]['wch'];
        }
      }
    }
    ws['!cols'] = result;
  }
  if(merges){
    if(!ws["!merges"]) ws["!merges"]=[];
    merges.forEach(a=>{
      ws["!merges"].push(a)
    })
  }
  ws.s = {
    alignment: { horizontal: "center", vertical: 'center'}
  }
  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  var wbout = XLSX.write(wb, {
    bookType: bookType,
    bookSST: false,
    type: 'binary'
  });
  saveAs(new Blob([s2ab(wbout)], {
    type: "application/octet-stream"
  }), `${filename}.${bookType}`);
  console.log(new Date().getTime())
}
/**企业端导出卡密卡号 */
export function revoke_export_template_to_excel ({
  shop_name,
  card_name,
  header,
  data,
  filename,
  autoWidth = true,
  bookType=  'xlsx'
} = {}) {
  const _data = [...header]
  filename = filename || 'excel-list'
  data = [...data]
  data.unshift(header);
  data.unshift(['商城名称'],[shop_name],['卡券名称'],[card_name]);
  var ws_name = "sheet";
  var wb = new Workbook(),
  ws = sheet_from_array_of_arrays(data);
  const styleList = ['A1', 'A3']
  const str = 'ABC';
  _data.forEach((item, index) =>{
    styleList.push(`${str[index]}5`)
  })
  
  styleList.forEach(element => {
    ws[element].s = {			
      font: { bold: true },
      alignment: { horizontal: "center", vertical: 'center'},
      fill: { fgColor: { rgb: 'D9D9D9' } },
    }
  });
  const styleList1 = ['A2', 'A4'];
  styleList1.forEach(element => {
    ws[element].s = {			
      alignment: { horizontal: "center", vertical: 'center'},
    }
  });
  console.log(_data)
  ws["!merges"] = []
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    if(index<4){
      ws["!merges"].push({
        s: {//s为开始
          c: 0,//开始列
          r: 0 + index//开始取值范围
        },
        e: {//e结束
          c: _data.length - 1,//结束列 
          r: 0 + index//结束范围
        }
      })
    } else break;
  }
  ws['!cols'] = []
  _data.forEach(item =>{ 
    ws['!cols'].push({wch: 20})
  })

  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  var wbout = XLSX.write(wb, {
    bookType: bookType,
    bookSST: false,
    type: 'binary'
  });
  saveAs(new Blob([s2ab(wbout)], {
    type: "application/octet-stream"
  }), `${filename}.${bookType}`);
}
export function export_template_to_excel({
  header,
  data,
  filename,
  autoWidth = true,
  bookType=  'xlsx'
} = {}) {
  const _data = [...header]
  filename = filename || 'excel-list'
  data = [...data]
  data.unshift(header);
  data.unshift(['商城名称'],['请在此栏输入商城名称'],['卡券名称'],['请在此栏输入卡券名称']);
  var ws_name = "sheet";
  var wb = new Workbook(),
  ws = sheet_from_array_of_arrays(data);
  const styleList = ['A1', 'A3']
  const str = 'ABC';
  _data.forEach((item, index) =>{
    styleList.push(`${str[index]}5`)
  })
  
  styleList.forEach(element => {
    ws[element].s = {			
      font: { bold: true },
      alignment: { horizontal: "center", vertical: 'center'},
      fill: { fgColor: { rgb: 'D9D9D9' } },
    }
  });
  const styleList1 = ['A2', 'A4'];
  styleList1.forEach(element => {
    ws[element].s = {			
      alignment: { horizontal: "center", vertical: 'center'},
    }
  });
  console.log(_data)
  ws["!merges"] = []
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    if(index<4){
      ws["!merges"].push({
        s: {//s为开始
          c: 0,//开始列
          r: 0 + index//开始取值范围
        },
        e: {//e结束
          c: _data.length - 1,//结束列 
          r: 0 + index//结束范围
        }
      })
    } else break;
  }
  ws['!cols'] = []
  _data.forEach(item =>{ 
    ws['!cols'].push({wch: 20})
  })

  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  var wbout = XLSX.write(wb, {
    bookType: bookType,
    bookSST: false,
    type: 'binary'
  });
  saveAs(new Blob([s2ab(wbout)], {
    type: "application/octet-stream"
  }), `${filename}.${bookType}`);
}
export function couponExport_template_to_excel({
  header,
  data,
  filename,
  autoWidth = true,
  bookType=  'xlsx'
} = {}) {
  const _data = [...header]
  filename = filename || 'excel-list'
  data = [...data]
  data.unshift(header);
  data.unshift(['商城名称'],['请在此栏输入商城名称'],['优惠券名称'],['请在此栏输入优惠券名称']);
  var ws_name = "sheet";
  var wb = new Workbook(),
  ws = sheet_from_array_of_arrays(data);
  const styleList = ['A1', 'A3']
  const str = 'ABC';
  _data.forEach((item, index) =>{
    styleList.push(`${str[index]}5`)
  })
  
  styleList.forEach(element => {
    ws[element].s = {			
      font: { bold: true },
      alignment: { horizontal: "center", vertical: 'center'},
      fill: { fgColor: { rgb: 'D9D9D9' } },
    }
  });
  const styleList1 = ['A2', 'A4'];
  styleList1.forEach(element => {
    ws[element].s = {			
      alignment: { horizontal: "center", vertical: 'center'},
    }
  });
  console.log(_data)
  ws["!merges"] = []
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    if(index<4){
      ws["!merges"].push({
        s: {//s为开始
          c: 0,//开始列
          r: 0 + index//开始取值范围
        },
        e: {//e结束
          c: _data.length - 1,//结束列 
          r: 0 + index//结束范围
        }
      })
    } else break;
  }
  ws['!cols'] = []
  _data.forEach(item =>{ 
    ws['!cols'].push({wch: 20})
  })

  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  var wbout = XLSX.write(wb, {
    bookType: bookType,
    bookSST: false,
    type: 'binary'
  });
  saveAs(new Blob([s2ab(wbout)], {
    type: "application/octet-stream"
  }), `${filename}.${bookType}`);
}

/** 下载延期数据模板 */
export function couponExport_down_to_excel(th, jsonData, defaultTitle) {

  /* original data */

  let data = jsonData;
  data.unshift(th);
  let ws_name = "SheetJS";

  let wb = new Workbook(), ws = sheet_from_array_of_arrays(data);

  /*设置worksheet每列的最大宽度*/
  const colWidth = data.map(row => row.map(val => {
    /*先判断是否为null/undefined*/
    if (val == null) {
      return { 'wch': 10 };
    }
    /*再判断是否为中文*/
    else if (val.toString().charCodeAt(0) > 255) {
      return { 'wch': val.toString().length * 2 };
    } else {
      return { 'wch': val.toString().length };
    }
  }))
  /*以第一行为初始值*/
  let result = colWidth[0];
  for (let i = 1; i < colWidth.length; i++) {
    for (let j = 0; j < colWidth[i].length; j++) {
      if (result[j]['wch'] < colWidth[i][j]['wch']) {
        result[j]['wch'] = colWidth[i][j]['wch'];
      }
    }
  }
  ws['!cols'] = result;

  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  let bout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });
  let title = defaultTitle || 'excel-list'
  saveAs(new Blob([s2ab(bout)], { type: "application/octet-stream" }), title + ".xlsx")
}
